import React from 'react';
import FlightTimes from '../FlightTimes/FlightTimes'
import './FlightDetails.scss'

export default (props)=> {

  const details  = props.flightDetails;

  return (
    <div className="flightDetails">
      <h3>Hinflug</h3>
      <FlightTimes flightDetails = {details.outbound}/>

      <h3>Rückflug</h3>
      <FlightTimes flightDetails = {details.inbound}/>

      <div className="details">
        <p>Alle Flugzeiten werden in der lokalen Ortszeit angegeben.</p>
        <p>Der Reiseveranstalter behält sich Änderungen der geplanten Flugzeiten im Rahmen der gesetzlichen und vertraglichen Möglichkeiten vor.</p>
        <p className="bold">Bitte beachten Sie, dass unter Umständen auch Flugkombinationen eingebucht werden können, die obig nicht aufgeführt sind, da aus technischen Gründen in seltenen Fällen nicht alle möglichen Flugkombinationen hier aufgelistet werden können.</p>
      </div>

    </div>)
}
